<template>
  <div class="pd-40">
    <div class="confirm-snag-page">
    <div class="container">
      <!-- Header with back button -->
      <div class="page-header">
        <button class="back-btn" @click="$router.go(-1)">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </button>
        <h1 class="page-title">Confirm</h1>
      </div>

      <div class="content-layout">
        <!-- Main Content (Left) -->
        <div class="main-content">
          <!-- Your Deal Section -->
          <section class="info-section">
            <h2 class="section-title">Your deal</h2>
            <div class="info-grid">
              <div class="info-item">
                <span class="info-label">Cash back</span>
                <span class="info-value">${{ productData?.cashbackmoney || '0' }}</span>
              </div>
              <!-- <div class="info-item">
                <span class="info-label">Marketplace</span>
                <span class="info-value">{{ productData.marketplace || 'amazon.com' }}</span>
              </div> -->
              <!-- <div class="info-item">
                <span class="info-label">Cost</span>
                <span class="info-value">1 snag</span>
                <span class="info-subtext">you have {{ userScore || 0 }} snags available</span>
              </div> -->
            </div>
          </section>

          <!-- Required for your cash back Section -->
          <!-- <section class="info-section">
            <h2 class="section-title">Required for your cash back</h2>
            <div class="action-card">
              <div class="action-icon">
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </div>
              <div class="action-details">
                <h3 class="action-title">Survey</h3>
                <p class="action-desc">Fill out a survey about the product.</p>
              </div>
            </div>
          </section> -->

          <!-- Complete by Section -->
          <!-- <section class="info-section">
            <span class="info-label">Complete by</span>
            <span class="info-value">{{ completeByDate }}</span>
          </section> -->

          <!-- We'll send your cash back to Section -->
          <section class="info-section">
            <!-- <h2 class="section-title">We'll send your cash back to</h2>
            <div class="email-input-wrapper">
              <div class="email-icon">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="2" y="4" width="20" height="16" rx="2"></rect>
                  <path d="M7 15h0M2 9.5h20"></path>
                </svg>
              </div>
              <input type="text" :value="userEmail" readonly class="email-input">
            </div> -->
            <p class="helper-text">
              
            </p>
          </section>

          <!-- Terms Section -->
          <div class="terms-text" v-html="orderdescription">
            
          </div>

          <!-- Final Button -->
          <button class="confirm-btn" @click="handleConfirm">Confirm</button>
        </div>

        <!-- Sidebar (Right) -->
        <aside class="sidebar">
          <div class="product-summary">
            <div class="product-header">
              <img :src="urls+productData.image" alt="product" class="summary-image">
              <div class="summary-info">
                <span class="summary-tag">Cash back survey</span>
                <h3 class="summary-title">{{ productData.title }}</h3>
                <div class="summary-rating">
                  <!-- <span class="star">★</span>
                  <span class="rating-val">4.2</span>
                  <span class="dot">·</span> -->
                  <!-- <span class="marketplace-val">{{ productData.marketplace || 'amazon.com' }}</span> -->
                </div>
              </div>
            </div>

            <div class="price-breakdown">
              <h3 class="breakdown-title">Your total</h3>
              <div class="price-row">
                <span>Original price</span>
                <span>${{ productData.originprice }}</span>
              </div>
              <div class="price-row total-row">
                <span>Product Price after cash back</span>
                <span class="final-price">${{ productData.price }}</span>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { productApi, userApi, commonApi } from '@/api/index.js'
import userStore from '@/store/user.js'

export default {
  name: 'ConfirmSnag',
  data() {
    return {
      productData: {},
      userScore: 0,
      userEmail: '',
      completeByDate: '',
      urls:this.httpUrl,
      orderdescription:""
    }
  },
  computed: {
    cashBack() {
      const origin = parseFloat(this.productData?.originprice) || 0
      const current = parseFloat(this.productData?.price) || 0
      const diff = origin - current
      return diff > 0 ? diff.toFixed(2) : '0.00'
    }
  },
  async mounted() {
    const id = this.$route.params.id
    await this.loadProductDetail(id)
    await this.loadUserInfo()
    this.loadConfig()
    this.calculateCompleteByDate()
  },
  methods: {
    async loadConfig() {
        try {
            const res = await commonApi.getConfig()
            this.orderdescription = res.data.orderdescription || ''
        } catch (e) {
            console.error('Failed to load config:', e)
        }
    },
    async loadProductDetail(id) {
      try {
        const res = await productApi.getProductDetail(id)
        if (res.code === 1) {
          this.productData = res.data
        }
      } catch (e) {
        console.error('Failed to load product detail:', e)
      }
    },
    async loadUserInfo() {
      if (userStore.state.isLoggedIn) {
        try {
          const res = await userApi.getUserInfo()
          if (res.code === 1) {
            this.userScore = res.data.score
            this.userEmail = res.data.email
          }
        } catch (e) {
          console.error('Failed to load user info:', e)
        }
      }
    },
    calculateCompleteByDate() {
      // Set to 60 days from now as a placeholder
      const date = new Date()
      date.setDate(date.getDate() + 60)
      this.completeByDate = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      })
    },
    async handleConfirm() {
      
      if (!this.productData.id) {
        this.$toast('Product information is not loaded.')
        return
      }
      const times = this.productData.times || 0
      const maxTimes = parseInt(this.productData.maxstocktimes) || 0
      if (times >= maxTimes) {
        this.$toast(`You have reached the maximum click limit (${maxTimes} times)`, 3000)
        return
      }
      try {
        const res = await productApi.submitOrder(this.productData.id)
        if (res.code === 1) {
          this.$toast(res.msg || 'Snagged successfully!')
          this.$router.push('/snags')
        } else {
          this.$toast(res.msg || 'Failed to snag the deal.')
        }
      } catch (e) {
        console.error('Failed to submit order:', e)
        this.$toast(e.message || 'An error occurred while submitting the order.')
      }
    }
  }
}
</script>

<style scoped>
.pd-40 {
  padding: 40px;
}
.confirm-snag-page {
  background: #fdfdfd;
  min-height: 100vh;
  /* padding: 40px 0; */
  color: #333;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 30px;
  padding-bottom: 20px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  color: #666;
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 28px;
  font-weight: 500;
  margin: 0;
}

.content-layout {
  display: flex;
  gap: 80px;
}

.main-content {
  flex: 1;
}

.info-section {
  margin-bottom: 35px;
}

.section-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
}

.info-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.info-value {
  font-size: 18px;
  font-weight: 400;
}

.info-subtext {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.action-card {
  background: #fdf5ea;
  border-radius: 20px;
  padding: 30px;
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.action-icon {
  background: none;
  color: #666;
}

.action-title {
  font-size: 22px;
  font-weight: 500;
  margin: 0 0 10px 0;
}

.action-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.email-input-wrapper {
  position: relative;
  margin-bottom: 15px;
}

.email-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
}

.email-input {
  width: 100%;
  padding: 15px 15px 15px 50px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #f9f9f9;
  font-size: 16px;
  color: #333;
}

.helper-text {
  font-size: 13px;
  color: #888;
  line-height: 1.5;
}

.terms-text {
  text-align: left;
  font-size: 12px;
  color: #999;
  line-height: 1.6;
  margin-bottom: 25px;
}

.terms-text a {
  color: #666;
  text-decoration: underline;
}

.confirm-btn {
  background: #1e2d3b;
  color: white;
  border: none;
  padding: 15px 50px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.confirm-btn:hover {
  opacity: 0.9;
}

/* Sidebar styles */
.sidebar {
  width: 350px;
}

.product-summary {
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 20px;
  background: white;
}

.product-header {
  display: flex;
  gap: 15px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.summary-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border-radius: 8px;
}

.summary-info {
  flex: 1;
}

.summary-tag {
  font-size: 12px;
  color: #999;
  display: block;
  margin-bottom: 4px;
}

.summary-title {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 8px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.summary-rating {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 5px;
}

.star {
  color: #333;
}

.dot {
  color: #ccc;
}

.price-breakdown {
  padding-top: 20px;
}

.breakdown-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
}

.price-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 15px;
  color: #666;
}

.total-row {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #333;
  font-weight: 500;
}

.final-price {
  font-size: 18px;
  font-weight: 700;
}

@media (max-width: 768px) {
  .content-layout {
    flex-direction: column-reverse;
  }
  .sidebar {
    width: 100%;
  }
  .pd-40 {
    padding: 10px;
  }
}
</style>
